import React, { useContext, useState } from "react";
import { TodoContext } from "../../TodoContext";
import "./TodoForm.css";

const TodoForm = () => {
  const [newValueTodo, setNewValueTodo] = useState("");

  const { addTodo, setOpenModal } = useContext(TodoContext);

  const onChange = (e) => {
    setNewValueTodo(e.target.value);
  };
  const onCancel = () => {
    setOpenModal(false);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    addTodo(newValueTodo);
    setOpenModal(false);
  };
  return (
    <form onSubmit={onSubmit}>
      <label>Escribe tu nueva Tarea</label>
      <textarea
        value={newValueTodo}
        onChange={onChange}
        placeholder="Escribe una nueva tarea"
      />
      <div className="TodoForm-buttonContainer">
        <button
          type="button"
          className="TodoForm-button TodoForm-button-cancel"
          onClick={onCancel}
        >
          Cancelar
        </button>

        <button className="TodoForm-button TodoForm-button-add" type="submit">
          Añadir
        </button>
      </div>
    </form>
  );
};

export default TodoForm;
